const RightSidebarFilled = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 22V2h20v20H2ZM14 4H4v16h10V4Z"
      fill="currentColor"
    />
  </svg>
);
export default RightSidebarFilled;
